// R115 maint — the calendar hub's maintenance feature (REQUESTS A2 + B6's WO
// branch). Imported once by ../features.ts; every file self-registers:
//   layer.ts        layer 'wo_unscheduled' (🔧 row badge), stats wo_open /
//                   wo_unscheduled / wo_booked_in_view / wo_overdue / wos_due,
//                   the 'wo' chip kind's move (drag = book / move)
//   bucket.ts       rail 'unscheduled_wos' + inspector 'wo_bucket' (search,
//                   group by home, Book… / Book on a date… / drag)
//   woInspector.ts  inspector 'wo' — the full Maintenance-card surface
//   newWo.ts        date action 'wo' ("Schedule a work order") + the new-WO sheet
//   css.ts          registerCss('maint')
// Server side: server/calendarLayers/wo_unscheduled.js (lib/woCalendar.mjs).
import { registerBusy } from '../registry';
import './css';
import './layer';
import './woInspector';
import './bucket';
import './newWo';
import { woEditorBusy } from './woInspector';
import { bookingBusy } from './book';
import { newWoBusy } from './newWo';
import { bucketBusy } from './bucket';

// The page vetoes its auto-refresh while any of these is true (R37 data-loss
// class): typed-but-unsaved WO edits / comments / reports, a write in flight,
// the occupied-night ask, the new-WO sheet, a bucket row being dragged.
registerBusy('maint', () => woEditorBusy() || bookingBusy() || newWoBusy() || bucketBusy());
